import React from 'react';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { useStyles } from './style';

interface PersonDeclaringProps {
  personDeclaring: string;
  personDeclaringId: string;
}

const PersonDeclaring = ({ personDetails }: { personDetails: PersonDeclaringProps }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { personDeclaring, personDeclaringId } = personDetails;

  return (
    <Box className={`${classes.container} ${classes.documentBadgeContainer}`}>
      <Typography variant="h3" className={classes.subheader}>
        {t('exam->>ParentParticulars.title')}
      </Typography>
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            capitalize={false}
            keyText={t('exam->>ParentParticulars.Name')}
            valueText={personDeclaring}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue keyText={t('exam->>ParentParticulars.NricFin')} valueText={personDeclaringId} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PersonDeclaring;
